import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, Optional, SimpleChanges, ViewChild } from '@angular/core';
import { OrderHeadGet, GetOrderHeadParams, OrderheadService } from '@app/services/orderhead.service';
import { catchError, EMPTY, from, ReplaySubject, Subject, switchMap, takeUntil } from 'rxjs';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { OrderHeadContextService } from './order-head-context.service';
import { OrderHeadEditComponent } from './order-head-edit/order-head-edit.component';

@Component({
    selector: 'tt-order-head',
    templateUrl: './order-head.component.html',
    styleUrls: ['./order-head.component.css'],
    providers: [OrderHeadContextService],
    standalone: false,
})
export class OrderHeadComponent implements OnInit, OnChanges, OnDestroy {
    @ViewChild(OrderHeadEditComponent)
    public orderHeadEdit?: OrderHeadEditComponent;

    @Input()
    public params?: GetOrderHeadParams;

    public params$ = new ReplaySubject<GetOrderHeadParams>(1);

    public destroy$ = new Subject<void>();

    public get?: OrderHeadGet;

    public orderHeadProvider = () => this.orderHeadEdit?.getOrderHeadFromForm() ?? this.get;

    constructor(
        private orderhead: OrderheadService,
        private context: OrderHeadContextService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
        this.params$
            .pipe(
                takeUntil(this.destroy$),
                switchMap((params) =>
                    from(this.orderhead.getOrderHead(params)).pipe(
                        catchError((err) => {
                            console.error(err);
                            return EMPTY;
                        }),
                    ),
                ),
            )
            .subscribe({
                next: (get) => {
                    this.get = get;
                    this.context.setOrderHead(get);
                    this.navigator?.setHeading?.(get.orderhead_heading);
                },
            });
    }

    public refreshGet() {
        if (!this.params) return;

        this.params$.next(this.params);
    }

    public async init(params: GetOrderHeadParams) {
        this.params = params;
        this.params$.next(params);
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '95vw', height: '98vh' });
            this.init(this.navigator.params as any);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']?.currentValue) {
            this.init(changes['params']?.currentValue);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.params$.complete();
    }
}
